
import { defineComponent } from 'vue';
import { PAGE_TYPE_LOGIN, PAGE_TYPE_REGISTER } from '../pageType';

export default defineComponent({
  methods: {
    btnLoginClick() {
      this.$emit('redirect', PAGE_TYPE_LOGIN);
    },

    btnRegisterClick() {
      this.$emit('redirect', PAGE_TYPE_REGISTER);
    },
  },
});
